import React from "react";

const Pricing = (props) => {
  const pricing = [
    {
      title: "Para Empresas",
      fIcon: "fi flaticon-medal",
      li1: "Recrutamento estratégico de talentos",
      li2: "Processos seletivos ágeis e humanizados",
      li3: "Consultoria especializada em Recursos Humanos",
      li4: "Soluções para retenção de profissionais",
      text: "Quero otimizar meu RH",
    },
    {
      title: "Para Profissionais",
      fIcon: "fi flaticon-trophy",
      li1: "Conexão com empresas de excelência",
      li2: "Oportunidades alinhadas ao seu perfil",
      li3: "Acompanhamento no processo seletivo",
      li4: "Desenvolvimento e crescimento de carreira",
      text: "Quero ser alocado",
    },
  ];

  return (
    <section className="wpo-pricing-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="wpo-section-title">
              <span>Conectamos talentos a oportunidades.</span>
              <h2>Soluções sob medida para empresas e profissionais</h2>
            </div>
          </div>
        </div>
        <div className="wpo-pricing-items">
          <div className="row">
            {pricing.map((pricing, ptem) => (
              <div className="col-md-6 col-12" key={ptem}>
                <div className="wpo-pricing-item">
                  <h2>{pricing.title}</h2>
                  <div className="price-icon">
                    <i className={pricing.fIcon}></i>
                  </div>
                  <ul>
                    <li className="fs-5 fw-bold">{pricing.li1}</li>
                    <li className="fs-5 fw-bold">{pricing.li2}</li>
                    <li className="fs-5 fw-bold">{pricing.li3}</li>
                    <li className="fs-5 fw-bold">{pricing.li4}</li>
                  </ul>
                  <a
                    href="https://wa.me/5511988799979?text=Ol%C3%A1!%20Gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20os%20servi%C3%A7os%20da%20Thomas%20Talent."
                    target="_blank"
                    rel="noreferrer"
                    className="btn theme-btn"
                  >
                    {pricing.text}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
